import React from "react";
import styled from "styled-components";
import * as Toast from "@radix-ui/react-toast";
import Styles from "@themes/Styles";

const StyledViewPort = styled(Toast.Viewport)`
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    padding: 25px;
    gap: 10px;
    width: 500px;
    max-width: 100vw;
    margin: 0;
    list-style: none;
    z-index: ${Styles.zIndexModal};
    outline: none;
`;

type LifeAtToastV2ProviderProps = {
    children: React.ReactNode;
};

export default function LifeAtToastV2Provider(props: LifeAtToastV2ProviderProps) {
    return (
        <Toast.Provider>
            {props.children}
            <StyledViewPort />
        </Toast.Provider>
    );
}
